import { Broker, BrokerAutoScalingGroupInstance } from '@amzn/amazonmq-opsconsole-client';
import { useCallback, useEffect, useState } from 'react';
import { getBrokerAutoScalingGroup } from '../../../../api/api';

interface Props {
    broker: Broker;
    refreshCnt: number;
    setAsgName: (asgName: string) => void;
    setAsgArn: (asgArn: string) => void;
}

export const useAsg = ({
    broker,
    refreshCnt,
    setAsgName,
    setAsgArn
}: Props) => {
    const [instances, setInstances] = useState<BrokerAutoScalingGroupInstance[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        try {
            setLoading(true);
            setError(null);
            getBrokerAutoScalingGroup(broker.id)
                .then(response => {
                    setInstances(response.instances || []);
                    setAsgName(response.autoScalingGroupName || '');
                    setAsgArn(response.autoScalingGroupARN || '');
                })
                .catch(error => {
                    console.error("getBrokerAutoScalingGroup failed to fetch: " + error);
                    setError(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error(error);
            setError(error instanceof Error ? error : new Error('Unknown error occurred'));
        } finally {
            setLoading(false);
        }
    }, [broker, refreshCnt]);

    return { instances, loading, error };
};